// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Browser__Debugger$SmartcutsMacros = require("../browser/Browser__Debugger.bs.js");

function enable(tabId, extensionId, targetId, param) {
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, "CSS.enable", undefined).then(function (param) {
              return Promise.resolve(undefined);
            });
}

var CSSComputedStyleProperty = {};

var methodName = "CSS.getComputedStyleForNode";

var Params = {};

var GetComputedStyleForNode = {
  methodName: methodName,
  Params: Params
};

function getComputedStyleForNode(nodeId, tabId, extensionId, targetId, param) {
  return Browser__Debugger$SmartcutsMacros.sendCommand(tabId, extensionId, targetId, methodName, {
              nodeId: nodeId
            });
}

exports.enable = enable;
exports.CSSComputedStyleProperty = CSSComputedStyleProperty;
exports.GetComputedStyleForNode = GetComputedStyleForNode;
exports.getComputedStyleForNode = getComputedStyleForNode;
/* Browser__Debugger-SmartcutsMacros Not a pure module */
